import './index.css';

import { ColorModeProvider, CSSReset, ThemeProvider } from '@chakra-ui/core';
import localStorage from 'localstorage-ttl';
import { Provider } from 'mobx-react';
import { onSnapshot } from 'mobx-state-tree';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import RootStore from './stores/RootStore';
import config from './utils/config';

let initialState = {};

if (localStorage.get(config.LOCAL_STORAGE_APP_KEY)) {
    const appStoreJSON = JSON.parse(`${localStorage.get(config.LOCAL_STORAGE_APP_KEY)}`);
    if (RootStore.is(appStoreJSON)) {
        initialState = appStoreJSON;
    }
}

const store = RootStore.create(initialState);

const expiration24Hours = 3.6e6 * 24;
onSnapshot(store, snapshot => {
    // expires in 24 hour
    if (store.auth.isAuthenticated) {
        localStorage.set(config.LOCAL_STORAGE_APP_KEY, JSON.stringify(snapshot), expiration24Hours);
    }
});

ReactDOM.render(
    <ThemeProvider>
        <CSSReset />
        <ColorModeProvider value="dark">
            <Provider store={store}>
                <App />
            </Provider>
        </ColorModeProvider>
    </ThemeProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
